import React from 'react';

interface MetricWithBarProps {
  metricComponent: React.ReactNode;
  barComponent: React.ReactNode;
  showNonAttributedData: boolean;
}

export const MetricWithBar: React.FC<MetricWithBarProps> = ({
  metricComponent,
  barComponent,
  showNonAttributedData,
}) => {
  return (
    <div className="h-full flex flex-row">
      <div className={`flex flex-col justify-center ${showNonAttributedData ? 'flex-1' : 'flex-1 w-full'}`}>
        {metricComponent}
      </div>
      {showNonAttributedData && (
        <div className="flex-1 h-full flex flex-col justify-end min-w-[120px]">{barComponent}</div>
      )}
    </div>
  );
};
